<template>
  <Layout>
    <div class="pt-12 sm:mx-8 md:mx-32">
      <Calendar></Calendar>
    </div>

    <div class="max-w-screen-xl mx-auto text-center">
      <p class="pb-4 text-chsoftblue px-5">
        Informace o platbě zálohy a přesném příjezdu a odjezdu naleznete v
        <Link class="underline text-chreddark" href="/cenik"
          >ceníku a informacích o platbě
        </Link>
      </p>
    </div>

    <div class="px-8 pt-8 pb-16 md:px-0 sm:mx-8 lg:mx-32 xl:mx-56">
      <CreateReservationForm></CreateReservationForm>
    </div>
  </Layout>
</template>

<script>
import Calendar from "../components/Calendar.vue";
import CreateReservationForm from "../components/CreateReservationForm.vue";
import Layout from "../Layouts/default.vue";
import { Link } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Calendar,
    CreateReservationForm,
    Layout,
    Link
  },
};
</script>
